const scrollToNode = (nodeToScroll) => {
  const nodeScrollTop =
    nodeToScroll.offsetTop === 0 && nodeToScroll.offsetParent
      ? nodeToScroll.offsetParent.offsetTop
      : nodeToScroll.offsetTop;
  nodeToScroll && window.scrollTo(0, nodeScrollTop);
};

export default scrollToNode;
